import classNames from "classnames";
import React from "react";

export const USER_COLORS = [
  "#F8C453",
  "#FF9F4D",
  "#F95B46",
  "#E63956",
  "#FF87A7",
  "#4D004C",
  "#3A14A7",
  "#4C50BE",
  "#6D8CF9",
  "#6EC8F9",
];

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user: any;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: (...args: any[]) => any;
  showName?: boolean;
  size?: "sm" | "md";
};

function UserAvatar({
  className,
  user,
  size,
  showName,
  onClick,
  ...rest
}: Props) {
  const color = USER_COLORS[user.icon_color_index];
  const style = Object.assign(
    {
      background: color,
    },
    user.is_contact && {
      borderColor: color,
    },
  );

  return (
    <div
      className={classNames(
        "user-avatar",
        { contact: user.is_contact, clickable: Boolean(onClick) },
        size && `size-${size}`,
        className,
      )}
      data-testid="user-avatar"
      onClick={onClick}
      {...rest}
    >
      <div key={user.id} className="user-avatar-icon" style={style}>
        {user.initials}
      </div>
      {showName && user.full_name && (
        <div className="user-avatar-name">{user.full_name}</div>
      )}
    </div>
  );
}

UserAvatar.defaultProps = {
  className: "",
  size: "md",
  showName: false,
};

export default UserAvatar;
